/**
 * Run countdowns (if any)
 */
const runCountdowns = () => {
    const countdownClocks = [...document.querySelectorAll('.countdown')];

    if (countdownClocks.length) {
        import('../../modules/countdownClock.js').then(({CountdownClock}) => {
            countdownClocks.forEach((countdown) => {
                const clock = countdown.querySelector('.clock');
                const endTimestamp = countdown.dataset.closeTimestamp;

                new CountdownClock(clock, endTimestamp, () => window.location.reload());
            });
        });
    }
};

export const bar = {
    runCountdowns,
};
